import React from 'react'
import filters, { type FilterOption, type FiltersData } from '../../data/download-filters'
import { DownloadsContext } from '../../contexts/DownloadsContext'
import { useTranslation } from 'react-i18next'

import styles from '../../styles/filter-box.module.css'
import { getFilters } from '../../js/download-match-utility'

type Props = {
    fieldName: string,
    width: number
}

export default function FilterBox({fieldName, width}: Props) {
    const filterData = React.useMemo<FiltersData>((): FiltersData => {
        const options: FiltersData = filters[fieldName];
        return options;
    }, [fieldName]);

    const {t} = useTranslation('downloads');

    const [downloadsState, setDownloadsState] = React.useContext(DownloadsContext);

    if (filterData == null){
        return <></>
    }

    const isChecked = (option: FilterOption) => {
        const selected = downloadsState.filters[fieldName];
        const isSelected = selected.some((o: FilterOption) => {
            return o.key == option.key;
        })
        return isSelected;
    }


    const handleSelect = (e : React.ChangeEvent<HTMLInputElement>) => {
        const {checked, value} = e.currentTarget;
        let selectedNew: string[] = [];
        downloadsState.filters[fieldName].forEach((f: FilterOption) => {
            selectedNew.push(f.key);
        })

        if (checked){
            selectedNew.push(value);
        }
        else{
            selectedNew = selectedNew.filter((s: string) => {
                return s != value;
            });
        }

        const selectedFilters = getFilters(fieldName, selectedNew);
        const filtersNew = {...downloadsState.filters};
        filtersNew[fieldName] = selectedFilters;
        setDownloadsState({...downloadsState, filters: filtersNew});
    }

    const filterInputs: React.JSX.Element[] = [];
    filterData.options.forEach((f : FilterOption) => {
        filterInputs.push(
            <div key={f.key} className={styles.inputContainer + ' ' + fieldName}>
                <label className={styles.checkboxContainer}>
                    {f.name}
                    <input type='checkbox' data-keyname={f.key} name={fieldName} checked={isChecked(f)} value={f.key} onChange={handleSelect} />
                    <span className={styles.checkbox}></span>
                </label>
            </div>
        )
    })

    let filterLabel = filterData.label;
    if (fieldName == 'host'){ filterLabel = t('hosts'); }
    if (fieldName == 'family'){ filterLabel = t('families'); }
    if (fieldName == 'os'){ filterLabel = t('operatingSystem'); }

  return (
    <div className={styles.filterBox + ' box'}>
        <h6>{filterLabel}</h6>
        <div className={styles.filterBoxContent}>
            {filterInputs}
        </div>
    </div>
  )
}